import { jsx as _jsx } from "react/jsx-runtime";
import { normalizeUnicode } from "pdfjs-dist";
import { memo, useEffect, useRef } from "react";
import { removeNullCharacters } from "../../../utils/removeNullCharacters";
/**
 * This is an empty element rendered at the end of the text layer.
 * It's used to improve text selection
 */ export const PDFPageTextLayerEnd = /*#__PURE__*/ memo(()=>{
    const containerRef = useRef(null);
    useEffect(()=>{
        const element = containerRef.current;
        const onMouseDown = ()=>{
            var _containerRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.classList.add("active");
        };
        const onCopy = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const selection = document.getSelection();
            if (!selection) return;
            try {
                var _event_clipboardData;
                (_event_clipboardData = event.clipboardData) === null || _event_clipboardData === void 0 ? void 0 : _event_clipboardData.setData("text/plain", removeNullCharacters(normalizeUnicode(selection.toString())));
            } catch (e) {
                console.error("Failed to copy text", e);
            }
        };
        const onPointerUp = ()=>{
            var _containerRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.classList.remove("active");
        };
        const onSelectionChange = ()=>{
            const selection = document.getSelection();
            if (!selection || selection.rangeCount === 0) {
                var _containerRef_current;
                (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.classList.remove("active");
                return;
            }
        };
        element === null || element === void 0 ? void 0 : element.addEventListener("mousedown", onMouseDown);
        element === null || element === void 0 ? void 0 : element.addEventListener("copy", onCopy);
        element === null || element === void 0 ? void 0 : element.addEventListener("pointerup", onPointerUp);
        element === null || element === void 0 ? void 0 : element.addEventListener("selectionchange", onSelectionChange);
        return ()=>{
            element === null || element === void 0 ? void 0 : element.removeEventListener("mousedown", onMouseDown);
            element === null || element === void 0 ? void 0 : element.removeEventListener("copy", onCopy);
            element === null || element === void 0 ? void 0 : element.removeEventListener("pointerup", onPointerUp);
            element === null || element === void 0 ? void 0 : element.removeEventListener("selectionchange", onSelectionChange);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: "pdfEndOfContent"
    });
});
PDFPageTextLayerEnd.displayName = "PDFPageTextLayerEnd";
